(function($) {
  Drupal.behaviors.ELBPC_r3_offer_header = {
    attach: function(context, settings) {
      //$(".js-offer-active").show();
      //$(".js-offer-inactive").show();
      //$(".js-offer-ended").show();
      var $container = $('.r3__container');
      var activeOfferCode = $container.attr('data-offer-active');
      var inactiveOfferCode = $container.attr('data-offer-inactive');
        
      // set our state based on offer code availability
      
      generic.jsonrpc.fetch({
        method: 'offer.inStockAndApplyable',
        params: [{ "OFFER_CODE" : activeOfferCode }],
        onSuccess: function(result) {
          var responseData1 = result.getValue();
          if (responseData1 === 1) {
            $(".js-offer-active").show();
          } else {
            // primary offer code is inactive - check secondary(after hiding the add to bag button)            
            generic.jsonrpc.fetch({
                method: 'offer.inStockAndApplyable',
                params: [{ "OFFER_CODE" : inactiveOfferCode }],
                onSuccess: function(result) {
                    var responseData2 = result.getValue();  
                    if (responseData2 === 1) {
                        $(".js-offer-inactive").show();
                    } else {
                        $(".js-offer-ended").show();
                    }
                },
                onFailure: function() {
                    // call failed
                    console.log('offers failure');
                }
            });
          }
        },
        onFailure: function() {
          // call failed
          console.log('offers failure');
        }
      });
      
      var $addToBag = $('.r3__add-to-bag');
      $addToBag.click(function(event) {
        var offerParams = {
            '_SUBMIT':'offer_code',
            'OFFER_CODE':activeOfferCode,
            'submit':'1'
        }
        var $overlay =  $('.r3__overlay_container').html();
        generic.jsonrpc.fetch({
            method: 'rpc.form',
            params: [offerParams],
            onSuccess: function() {
                $.colorbox({ html: $overlay });
            },
            onFailure: function() {
                // call failed
                console.log('add to bag failure');
            }
        }); 
      });
      

    }
  };
})(jQuery);